import { render, staticRenderFns } from "./anatip.vue?vue&type=template&id=ee405bd6&"
import script from "./anatip.vue?vue&type=script&lang=js&"
export * from "./anatip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports